module.exports = __webpack_public_path__ + "static/img/map2.a497871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/map2.png
// module id = 5kP6
// module chunks = 1